import { t } from "i18next";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { surveyPublicContentUrl } from "../../helperData/ApiAddress";
import MediaPreview from "./MediaPreview";
import "./styles.scss";

export default function ContentPublicPage() {
    const { token } = useParams();
    const [content, setContent] = useState(null);
    const [invalid, setInvalid] = useState(false);

    useEffect(() => {
        setInvalid(false);
        setContent(null);
        axios
            .get(surveyPublicContentUrl(token))
            .then((response) => setContent(response.data))
            .catch(() => setInvalid(true));
    }, [token]);

    if (invalid) {
        return (
            <div className="content-public-page">
                <p>{t("contentStudio.send.publicInvalid")}</p>
            </div>
        );
    }

    if (!content) {
        return (
            <div className="content-public-page">
                <p>{t("contentStudio.loading")}</p>
            </div>
        );
    }

    return (
        <div className="content-public-page">
            <h1>{content.name || t("contentStudio.send.publicTitle")}</h1>
            {content.description ? <p>{content.description}</p> : null}
            <MediaPreview content={content} />
        </div>
    );
}
